import { render, staticRenderFns } from "./Quize.vue?vue&type=template&id=cb0cdac4&scoped=true"
import script from "./Quize.vue?vue&type=script&lang=js"
export * from "./Quize.vue?vue&type=script&lang=js"
import style0 from "./Quize.vue?vue&type=style&index=0&id=cb0cdac4&prod&lang=scss&scoped=true"
import style1 from "./Quize.vue?vue&type=style&index=1&id=cb0cdac4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0cdac4",
  null
  
)

export default component.exports